import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Formik, Field, Form } from 'formik';
import { toast } from "react-toastify";
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import FormikErrorFocus from "formik-error-focus";
import { SlDrawer, SlInput ,SlIcon} from '@shoelace-style/shoelace/dist/react';
import { useFormik } from "formik";
import api from "../../services/api";
import { formatDateWithTime } from '../../utils/dateFormat';
import NoDataFound from '../../shared/NoDataFound';
import { Toast } from '../../shared/Toast';
import Paginator from '../../shared/Paginator';
import config from '../../config';
import TableLoader from '../../shared/TableLoader';
import { useDispatch, useSelector } from 'react-redux';
import { ScrollContainer } from 'react-indiana-drag-scroll';

import { debounce } from '../../utils/Debounce';
import { SlTooltip, SlIconButton, SlButton } from '@shoelace-style/shoelace/dist/react';
import { financeUserTypes } from '../../utils/constants';
import Select from 'react-select'
import PendingRequestModal from '../MakerChecker/components/PendingRequestModal';

const initialFinance = {
  name: '',
  email: '',
  mobile: '',
  password: '',
  user_type: 0,
}
let initialValues = JSON.parse(JSON.stringify(initialFinance));

const userRole_Options = [
    {value:1, label:"Maker"},
    {value:2, label:"Checker"},
    {value:3, label:"Maker & Checker"},
]

const FinanceSchema = Yup.object().shape({
  name: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s]*$/, "Name can't start with white space and should not contain special characters").required('Name is required'),
  email: Yup.string().email().required('Email is required'),
  mobile: Yup.string()
    .matches(/^[6-9]\d{9}$/, "Invalid Mobile number")
    .min(10, "Mobile must be 10 digits")
    .max(10, "Mobile must be 10 digits")
    .required("Mobile Number is required"),
  password: Yup.string().matches(/^[a-zA-Z0-9.\/!@#$%^&*+~?-]+$/, "Password should not contain any white space").required("Password is required"),
  user_type: Yup.number().required("Designation is Required")
})


function Finance() {

  const navigate = useNavigate()

  const [delId, setDelId] = useState(-1);
  const [delname, setDelname] = useState("")
  const [del, setDel] = useState(false);
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [flag, setFlag] = useState('')
  const [id, setId] = useState('');
  const [search, setSearch] = useState("")

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [otp, setOtp] = useState({});
  const [editingRoles, setEditingRoles] = useState({});
  const [userRoles,setUserRoles]=useState({})
  const [tempRoles,setTempRoles]=useState({});

  const [selectedMcId,setSelectedMcId] = useState('');
  const handleCloseModal = () => {
      setSelectedMcId(null);
  };
  const handlePageClick = (event) => {
    // const newOffset = (event.selected * config.PER_PAGE) % data.length;
    // setItemOffset(newOffset);
    setCurrentPage(event.selected);
    loadData(search, event.selected);
    setOtp({});
  };
  const HeaderSearch = useSelector(state => state.Head.adssearch)

  const handleClose = () => {
    setShow(false);
    setSubmit(false);
    initialValues = JSON.parse(JSON.stringify(initialFinance));
    formik.setValues(initialValues);
    // initialFinance.name = ''
    // initialFinance.email = ''
    // initialFinance.mobile = ''
    // initialFinance.password = ''
  }

  const handleShow = (choose, item) => {
    if (choose === "add") {
      formik.setValues(item);
      setShow(true);
    }
    if (choose === 'edit') {
      initialValues.email = item.email
      initialValues.name = item.name
      initialValues.mobile = item.mobile
      initialValues.password = item.password
      initialValues.user_type = item.user_type
      initialValues.status = item.status
      formik.setValues(initialValues);
      setShow(true)
    }
  };

  useEffect(() => {
    Header()
  }, [HeaderSearch])

  const deleteFinancer = async (id1) => {
    try {
      await api({
        url: `/user/finance_team/${id1}`,
        method: "DELETE",
        responseType: "json"
      });
      toast.success("Finance Person Deleted Successfully");
      setCurrentPage(0);
      setSearch('');
      loadData(search, 0);
    } catch (error) {
      let er = error?.response?.message || "Something went wrong"
      Toast("error", er)
      if (error.response.status === 401)
        navigate("/")
    }
  }


  const loadData = async (searchString = '', page = 0) => {
    try {
      setLoader(true);
      let res = await api({
        url: `/user/finance_team/getFinanceteam`,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          search: searchString
        }
      });
      setData(res.data.data.length ? res.data.data : [])
      const TempRoles = {};
      (res.data.data || []).forEach(user => {
          const mc_Role = userRole_Options.find(role=>role.value===user.mc_role);
          if(mc_Role) TempRoles[user.financer_id] = mc_Role;
      });
      setTempRoles(TempRoles);
      setUserRoles(TempRoles);
      setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
      setLoader(false);
    } catch (error) {
      //toast.error("Something went wrong")
      setLoader(false);
      if (error.response.status === 401)
        navigate("/")
    }
  }

  const Header = () => {
    setSearch(HeaderSearch);
    setCurrentPage(0);
    loadData(HeaderSearch, 0);
  }

  // useEffect(() => {
  // const timer = setTimeout(() => {
  // loadData(search, 0)
  // }, 200);

  // return () => clearTimeout(timer);
  // }, []);

  // useEffect(() => {
  //   loadData();
  // }, [currentPage]);

  const searchData = e => {
    setSearch(e.target.value);
    setCurrentPage(0);
    loadData(e.target.value, 0);
    setOtp({});
  }
  function handleRequestClose(event) {
    if (event.detail.source === 'overlay') {
      event.preventDefault();
    }
  }
  const handledelClose = () => {
    setDel(false)
  }
    const startEditing = (financer_id) => {
        setEditingRoles(prev => ({ ...prev, [financer_id]: true }));
        setTempRoles(prev => ({ ...prev, [financer_id]: userRoles[financer_id] }));
    };

    const cancelEditing = (financer_id) => {
        setEditingRoles(prev => ({ ...prev, [financer_id]: false }));
        setTempRoles(prev => ({ ...prev, [financer_id]: userRoles[financer_id] }));
    };

  const saveRole = async (financer_id) => {
        setUserRoles(prev => ({ ...prev, [financer_id]: tempRoles[financer_id] }));
        setEditingRoles(prev => ({ ...prev, [financer_id]: false }));
        let res = await api({
            url: `/user/finance_team/user_role`,
            method: "POST",
            responseType: "json",
            data: {
                financer_id,
                mc_role:tempRoles[financer_id]?.value
            },
        });
        if (res?.status==="SUCCESS") {
            Toast('success', res.message);
            loadData(search,currentPage);
        }else{
            Toast("error","Failed To Change User Role");
        }
  };

  const handleChange = (financer_id, selectedOption) => {
    setTempRoles(prev => ({ ...prev, [financer_id]: selectedOption }));
  };

  let formik = useFormik({
    initialValues: JSON.parse(JSON.stringify(initialFinance)),
    validationSchema: FinanceSchema,
    onSubmit: async (values) => {
      if (flag === 'add') {
        try {
          let res = await api({
            url: `/user/finance_team`,
            method: "POST",
            responseType: "json",
            data: {...values,ref_table:"finance_team"}
          });
          if (res?.data?.code === 500) {
            Toast('error', res.data.message);
          } else {
            Toast("success", "Finance Add Request Sent Successfully");
            handleClose();
            setCurrentPage(0);
            setSearch('');
            loadData(search, 0);
            setOtp({});
          }
        } catch (error) {
          let er = error?.response?.message || "Something went wrong"
          Toast("error", er)
          if (error.response.status === 401)
            navigate("/")
        }
      }
      if (flag === 'edit') {
        try {
          await api({
            url: `/user/finance_team/${id}`,
            method: "PUT",
            responseType: "json",
            data: {...values,ref_table:"finance_team"}
          });
          Toast("success", "Finance updated Successfully");
          handleClose()
          loadData(search, currentPage);
          setOtp({});
          values.name = ''
          values.email = ''
          values.mobile = ''
          values.password = ''
          values.user_type = 0
        } catch (error) {
          let er = error?.response?.message || "Something went wrong"
          Toast("error", er)
          if (error.response.status === 401)
            navigate("/")
        }
      }
    }
  });

  const viewOTP = async (mobile, userType, index) => {
    try {
      let res = await api({
        url: `/user/sales_persons/viewOTP`,
        method: "POST",
        responseType: "json",
        data: {
          mobileno: mobile,
          type: userType,
        },
      });
      if (res?.code === 200) {
        const updatedOtpData = { ...otp };
        updatedOtpData[index] = res?.data?.length ? res?.data[0].otp : "OTP not found"
        setOtp(updatedOtpData);
        // Toast("success", "OTP displayed Successfully");
      } else {
        Toast("error", res.data.message);
        const updatedOtpData = { ...otp };
        updatedOtpData[index] = '';
        setOtp(updatedOtpData);
      }
    } catch (error) {
      let er = error?.response?.message || "Something went wrong";
      Toast("error", er);
      setOtp({})
      if (error.response.status === 401) navigate("/");
    }

  }


  return (
    <>
      <SlDrawer label="Are you sure!" open={del} onSlRequestClose={handleRequestClose} onSlAfterHide={handledelClose} >
        <p>The Finance Person <span style={{ fontFamily: "Arial", fontWeight: "bold" }}>{delname}</span> will be deleted</p>
        <div className='d-flex gap-2'>
          <Button variant="success" onClick={() => setDel(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => { setDel(false); deleteFinancer(delId) }}>Confirm</Button>
        </div>
      </SlDrawer>
      {/* <Modal show={del}>
        <Modal.Header>
          <Modal.Title>Are you sure!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>The Finance Person <h6 className='inline underline'>{delname}</h6> will be deleted</p>
          <div className='flex gap-2'>
            <SlButton size='small' variant="danger" onClick={() => setDel(false)}>Cancel</SlButton>
            <SlButton size='small' variant="primary" onClick={() => { setDel(false); deleteFinancer(delId) }}>Confirm</SlButton>
          </div>
        </Modal.Body>
      </Modal> */}
      <div className='flex gap-4 justify-end mb-4'>
        <SlInput size="small" id="myInput" onSlInput={debounce(searchData, 500)} placeholder="Search By Name / Email / Mobile.." >
        <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
        </SlInput>
        <SlButton size="small" variant="primary" onClick={() => { handleShow("add", {}); setFlag('add') }}>Add Finance</SlButton>
      </div>
      <SlDrawer label="Create Finance Person" open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} >
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <label className="mb-1"> Name</label><span className="text-red-600">*</span>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Financer Name"
              aria-label=""
              name="name"
              value={formik.values.name}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.name ? (
              <div className="text-red-600	">{formik.errors.name}</div>
            ) : null}
          </div>
          <div className="mb-3" >
            <label className="mb-1">Email</label><span className="text-red-600">*</span>
            <input
              type='email'
              className="form-control"
              placeholder='Enter Email'
              name='email'
              aria-label=""
              value={formik.values.email}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.email ? (
              <div className="text-red-600	">{formik.errors.email}</div>
            ) : null}
          </div>
          <div className="mb-3" >
            <label className="mb-1"> Mobile No</label><span className="text-red-600">*</span>
            <input
              className="form-control"
              type='tel'
              name='mobile'
              placeholder='Enter Mobile No'
              aria-label=""
              value={formik.values.mobile}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.mobile ? (
              <div className="text-red-600	">{formik.errors.mobile}</div>
            ) : null}
          </div>
          <div className="mb-3" >
            <label className="mb-1"> Password</label><span className="text-red-600">*</span>
            <input
              className="form-control"
              type='text'
              name='password'
              placeholder='Enter Password'
              aria-label=""
              value={formik.values.password}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.password ? (
              <div className="text-red-600	">{formik.errors.password}</div>
            ) : null}

          </div>
          <div className="mb-3">
            <label className="mb-1">Designation</label><span className="text-red-600">*</span>
            <select
              className="form-select"
              aria-label="Default select example"
              name="user_type"
              placeholder="Select Type"
              onBlur={formik.handleBlur}
              value={formik.values.user_type}
              onChange={async (e) => {
                formik.handleChange(e);
              }}
            >
              {financeUserTypes.map(item => <option value={item.value}>{item.label}</option>)}
            </select>
            {submit && formik.errors.user_type ? (
              <div className="text-red-600	">{formik.errors.user_type}</div>
            ) : null}
          </div>
          {flag === "edit" && (
            <div className="mb-3 form-check form-switch">
              <label className="form-check-label">
                Status ({formik.values.status ? "Active" : "Inactive"})
              </label>
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                checked={formik.values.status}
                onChange={() => {
                  formik.setFieldValue("status", formik.values.status ? 0 : 1)
                }}
              />
            </div>
          )}
          <div slot="footer">
            <SlButton
              type="submit"
              variant="primary"
              size="small"
              onClick={(e) => setSubmit(true)}>Submit</SlButton>
          </div>

        </form>
      </SlDrawer>
      {/* <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Create Finance Person</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={initialFinance}
            validationSchema={FinanceSchema}
            onSubmit={async (values) => {
              if (flag === 'add') {
                try {
                  let res = await api({
                    url: `/user/finance_team`,
                    method: "POST",
                    responseType: "json",
                    data: values
                  });
                  if (res?.data?.code === 500) {
                    Toast('error', res.data.message);
                  } else {
                    Toast("success", "Finance Added Successfully");
                    handleClose();
                    setCurrentPage(0);
                    setSearch('');
                    loadData(search, 0);
                  }
                } catch (error) {
                  let er = error?.response?.message || "Something went wrong"
                  Toast("error", er)
                  if (error.response.status === 401)
                    navigate("/")
                }
              }
              if (flag === 'edit') {
                try {
                  await api({
                    url: `/user/finance_team/${id}`,
                    method: "PUT",
                    responseType: "json",
                    data: values
                  });
                  Toast("success", "Finance updated Successfully");
                  handleClose()
                  loadData(search, currentPage);
                  values.name = ''
                  values.email = ''
                  values.mobile = ''
                  values.password = ''
                } catch (error) {
                  let er = error?.response?.message || "Something went wrong"
                  Toast("error", er)
                  if (error.response.status === 401)
                    navigate("/")
                }
              }
            }}>
            {({ values, errors, touched }) => (
              <Form>
                <div className="mb-3" >
                  <label className="mb-1"> Name</label>
                  <Field className="form-control" type='text' name='name' placeholder='Enter Financer Name' />
                  {errors.name && touched.name ? (<div className='text-red-600'>{errors.name}</div>) : null}</div>
                <div className="mb-3" >
                  <label className="mb-1">Email</label>
                  <Field className="form-control" type='email' name='email' placeholder='Enter Email' />
                  {errors.email && touched.email ? (<div className='text-red-600'>{errors.email}</div>) : null}</div>
                <div className="mb-3" >
                  <label className="col-sm-4 col-form-label"> Mobile No</label>
                  <Field className="form-control" type='tel' name='mobile' placeholder='Enter Mobile No' />
                  {errors.mobile && touched.mobile ? (<div className='text-red-600'>{errors.mobile}</div>) : null}</div>
                <div className="mb-3" >
                  <label className="mb-1"> Password</label>
                  <Field className="form-control" type='text' name='password' placeholder='Enter Password' />
                  {errors.password && touched.password ? (<div className='text-red-600'>{errors.password}</div>) : null}</div>
                <div className='text-end'><button className="btn btn-secondary" onClick={handleClose}> Cancel</button>
      <div>
        <SlButton variant='primary' size='small' type='submit'>Submit</SlButton>
      </div>
       </div> 
                <FormikErrorFocus
                  offset={0}
                  align={"top"}
                  focusDelay={100}
                  ease={"linear"}
                  duration={100}
                />
              </Form>
            )
            }
          </Formik >
        </Modal.Body >
        <Modal.Footer>
        </Modal.Footer>
      </Modal > */}
      < div className='mb-4' >
        <ScrollContainer>
        <table className='table table-bordered'>
          <thead className="sticky top-0 ">
            <tr>
              <th >Name</th>
              <th >Email</th>
              <th >Mobile</th>
              <th >Password</th>
              <th >Designation</th>
              <th >Status</th>
              <th>Created Date</th>
              <th>Created By</th>
              <th>View OTP</th>
              <th>Actions</th>
              <th>User Role</th>
            </tr>
          </thead>
          {(data?.length && !loader) ? (
            <tbody>
              {data.map((item, index) => {
                return (
                  <tr key={item.financer_id} className="group/details hover:bg-slate-100">
                    <th scope="row" className="flex items-center justify-center text-center gap-2">
                        {item?.mc_actions?.length ?<button className="h-2 w-2 px-1 py-1 rounded-full bg-orange-300" title={`pending edit action by ${item?.mc_actions?.[0]?.mc_user_name}`} onClick={() => setSelectedMcId(item?.mc_actions?.[0]?.mc_id)}></button>: null}
                        <span>{item.name}</span>
                    </th>
                    <td >{item.email}</td>
                    <td >{item.mobile}</td>
                    <td >{item.password}</td>
                    <td >{financeUserTypes.find(fitem => fitem.value === item.user_type)?.label}</td>
                    <td>
                      <span className={item.status ? "full-badge text-center" : "unpaid-badge text-center"}>
                        {item.status ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td >{formatDateWithTime(item.created_date)}</td>
                    <td >{item.user_name || '-'}</td>
                    <td>
                      {otp[index] ? (
                        <span>{otp[index]}</span>
                      ) : (
                        <SlTooltip content="View OTP">
                          <SlIconButton
                            library="lucide"
                            name="eye"
                            onClick={() => viewOTP(item.mobile, "financer", index)}
                          ></SlIconButton>
                        </SlTooltip>
                      )}
                    </td>
                    <td >
                      <div className='inline-flex gap-3'>
                        <SlTooltip content="Edit Finance">
                          <SlIconButton
                            library="lucide"
                            name="edit"
                            onClick={() => { handleShow("edit", item); setFlag('edit'); setId(item.financer_id) }}></SlIconButton>
                        </SlTooltip>
                        <form action="" method="POST">
                          {/* <SlTooltip content="Delete Finance">
                            <SlIconButton
                              library="lucide"
                              name="trash-2"
                              onClick={() => { setDel(true); setDelId(item.financer_id); setDelname(item.name) }}></SlIconButton>
                          </SlTooltip> */}
                        </form>
                      </div>
                    </td>
                    <td>
                                                                {editingRoles[item.financer_id] ? (
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <Select
                                                                        options={userRole_Options}
                                                                        value={tempRoles[item.financer_id]}
                                                                        onChange={(selectedOption) => handleChange(item.financer_id, selectedOption)}
                                                                        styles={{
                                                                            container: (base) => ({ ...base, minWidth: 150 }),
                                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }) 
                                                                        }}
                                                                        menuPortalTarget={document.body}
                                                                    />
                    
                                                                    <button onClick={()=>saveRole(item.financer_id)} className='bg-green-400 rounded-lg px-2 py-1 ml-1'>Save</button>
                                                                    <button onClick={()=>cancelEditing(item.financer_id)} className='bg-blue-400 rounded-lg px-2 py-1 ml-1'>Cancel</button>
                                                                    </div>
                                                                ) : (
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <span>{userRoles[item.financer_id]?.label || 'No Role'}</span>
                                                                    <SlIconButton library='lucide' name='edit' onClick={()=>startEditing(item.financer_id)}/>
                                                                    </div>
                                                                )}
                                                            </td>
                  </tr>
                )
              })}
            </tbody>) : ((!data?.length && !loader)
              ? <NoDataFound colspan="9" />
              : <TableLoader colspan="9" />
          )
          }
        </table>
        </ScrollContainer>
      </div >
      <div className="flex justify-end"> {totalPages > 1 && <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />}</div>
      <PendingRequestModal mc_id={selectedMcId} isOpen={selectedMcId} onClose={handleCloseModal} />
    </>
  )
}

export default Finance